import { ROUTE_ACCOUNT_EDIT_MEMBERSHIP } from '@/constants/routes';
import { Box, Flex, Text } from '@cmpsr/components';
import AccountItem from '../../../common/account-item';
import EditLink from '../edit-link/edit-link';

export type MembershipProps = {
  type: string;
  usdPrice: number;
  renewalDate: string;
  cancelAtPeriodEnd: boolean;
  subscriptionStatus?: string;
};

export default function Membership({
  type,
  usdPrice,
  renewalDate,
  cancelAtPeriodEnd,
  subscriptionStatus,
}: MembershipProps) {
  const isVipAccess = type === 'VIP Access' || type === 'VIP';

  return (
    <Flex
      flexDirection="column"
      p={{ base: 'spacer-4', md: 'spacer-6' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      backgroundColor="background-light"
      gap="spacer-4"
    >
      <Box display="flex" justifyContent="space-between">
        <Text variant="text-header-M">Membership</Text>
        {!isVipAccess && <EditLink route={ROUTE_ACCOUNT_EDIT_MEMBERSHIP} />}
      </Box>
      <AccountItem label="type" value={isVipAccess ? 'VIP membership' : `${type} membership`} />
      {subscriptionStatus && <AccountItem label="status" value={subscriptionStatus} />}
      <AccountItem label="price" value={isVipAccess ? 'Free Forever' : `$ ${usdPrice}/year (Billed annually)`} />
      {!isVipAccess && (
        <AccountItem
          label={
            subscriptionStatus === 'Trial'
              ? 'trial end date'
              : cancelAtPeriodEnd
                ? 'membership end date'
                : 'renewal date'
          }
          value={renewalDate}
        />
      )}
    </Flex>
  );
}
